import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "social" }
const _hoisted_2 = ["href"]
const _hoisted_3 = ["src", "alt"]

import {inject} from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'SocialIcons',
  setup(__props) {

const store:any=inject(`store`)
const logoArray=store.getters.getLogoArray

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(logoArray), (logo) => {
      return (_openBlock(), _createElementBlock("a", {
        href: logo.href,
        key: logo.id,
        target: "_blank"
      }, [
        _createElementVNode("img", {
          src: logo.src,
          alt: logo.alt
        }, null, 8, _hoisted_3)
      ], 8, _hoisted_2))
    }), 128))
  ]))
}
}

})